import React from 'react';

interface SummaryBarProps {
  selectedCount: number;
  totalCount: number;
  focusedNodeName: string;
  searchQuery: string;
  onSearchChange: (q: string) => void;
  onClearAll: () => void;
  canClear: boolean;
}

export const SummaryBar: React.FC<SummaryBarProps> = ({
  selectedCount,
  totalCount,
  focusedNodeName,
  searchQuery,
  onSearchChange,
  onClearAll,
  canClear,
}) => {
  return (
    <div
      className="device-selector__summary d-flex align-items-center gap-3 px-3 py-2"
      aria-live="polite"
    >
      <span className="text-info-emphasis fw-medium">
        <i className="fas fa-circle-check me-2"></i>
        {selectedCount} of {totalCount} devices selected
      </span>
      <span className="text-muted">·</span>
      <span className="text-muted text-truncate" title={focusedNodeName}>
        {focusedNodeName}
      </span>
      <div className="ms-auto d-flex align-items-center gap-2">
        <div className="input-group input-group-sm" style={{ width: '220px' }}>
          <span className="input-group-text bg-white border-end-0">
            <i className="fas fa-magnifying-glass text-muted"></i>
          </span>
          <input
            type="search"
            className="form-control border-start-0"
            placeholder="Search devices…"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            aria-label="Search devices"
          />
        </div>
        <button
          type="button"
          className="btn btn-sm btn-outline-secondary"
          onClick={onClearAll}
          disabled={!canClear}
        >
          Clear all
        </button>
      </div>
    </div>
  );
};
